module.exports = __webpack_public_path__ + "static/media/1.79df01b8.png";